import { httpClient } from "@services/api/httpClient";

const updateOfferApplicant = async (data: any) => {
    const response = await httpClient.post("/offer-applicant/update", data);
    return response.data;
};

export default updateOfferApplicant;
